import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFaceSadTear } from "@fortawesome/free-regular-svg-icons";
import INFO from "../data/user";
import Logo from "../components/common/logo";

import "./styles/404.css";

const Notfound = () => {
	return (
        <div className="not-found">
            <Helmet>
                <title>{`404 | ${INFO.main.title}`}</title>
                <meta name="robots" content="noindex" />
                <link rel="canonical" href={`${INFO.socials.website}/404`} />
            </Helmet>
			<div className="not-found-content">
				<div className="not-found-logo">
					<Logo width={80} />
				</div>
				
				<div className="not-found-message">
					<h1 className="not-found-title">
						404 <FontAwesomeIcon icon={faFaceSadTear} alt="Sad face icon" />
					</h1>
					<p className="not-found-text">
						Oops! The page you're looking for seems to have taken a styling break.
					</p>
					<p className="not-found-subtext">
						Don't worry, our expert stylists can help you find your way back!
					</p>
					<div className="not-found-actions">
						<Link to="/" className="not-found-button primary">
							Return Home
						</Link>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Notfound;
